<div class="border border-1 border p-4 mb-4">
  <div class="d-flex justify-content-between align-items-center">
    <mat-form-field>
      <mat-label>Client Perval</mat-label>
      <mat-select>
        <mat-option *ngFor="let client of clients" [value]="client">
          {{ client }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Mode de paiement</mat-label>
      <mat-select>
        <mat-option *ngFor="let mode of modesDePaiement" [value]="mode">
          {{ mode }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Renouvellement auto</mat-label>
      <mat-select>
        <mat-option
          *ngFor="let renouvellementAutoValue of renouvellementAutoValues"
          [value]="renouvellementAutoValue"
        >
          {{ renouvellementAutoValue }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox>Client Perval uniquement</mat-checkbox>
  </div>

  <div class="d-flex justify-content-end mt-3">
    <button mat-button class="me-3">Réinitialiser les filtres</button>
    <button mat-raised-button color="primary" class="me-3">Rechercher</button>
    <button mat-raised-button color="accent">Exporter</button>
  </div>
</div>
